// openWaSend — ask the app to send a WhatsApp message from AONE's own number.
//
// One entry point for every "message this person" button. It dispatches a
// window event that WaSendHost (mounted once in Layout) turns into the send
// sheet. A window event, not a React context, so the vanilla-DOM phone
// enhancer and any lazy chunk can trigger it without an import cycle.
//
// Why this replaced wa.me links: a wa.me link opens the staff member's
// personal WhatsApp. Nothing is logged, consent is never checked, and the
// inbox never sees the message. Every send now goes through the gateway.
export const WA_SEND_EVENT = 'aone:wa-send';

export function openWaSend({ phone, name, brandId, text, clientId, leadId, queue, source } = {}) {
  if (typeof window === 'undefined' || !phone) return;
  window.dispatchEvent(new CustomEvent(WA_SEND_EVENT, {
    detail: { phone: String(phone), name: name || '', brandId: brandId || '', text: text || '', clientId: clientId || null, leadId: leadId || null, queue: queue || 'sales', source: source || '' },
  }));
}

export function normalisePhoneForDisplay(phone) {
  const d = String(phone || '').replace(/\D/g, '');
  const ten = d.length >= 10 ? d.slice(-10) : d;
  return ten.length === 10 ? `+91 ${ten.slice(0, 5)} ${ten.slice(5)}` : d;
}
